import { IdValue } from '../../../shared/models/id-value.model';

export enum EmploymentStatus {
  Former = 0,
  SecondaryCurrent = 1,
  Primary = 2,
}

export const ownershipShareTypes: IdValue[] = [
  new IdValue(0, 'Select'),
  new IdValue(1, 'Greater Than or Equal To 25 Percent'),
  new IdValue(2, 'Less Than 25 Percent'),
];

export const employmentIncomeTypes: IdValue[] = [
  new IdValue(1, 'Base Income'),
  new IdValue(2, 'Overtime'),
  new IdValue(3, 'Bonus'),
  new IdValue(4, 'Commission'),
  new IdValue(19, 'Military Base Pay'),
  new IdValue(20, 'Military Rations Allowance'),
  new IdValue(21, 'Military Flight Pay'),
  new IdValue(22, 'Military Hazard Pay'),
  new IdValue(23, 'Military Clothes Allowance'),
  new IdValue(24, 'Military Quarters Allowance'),
  new IdValue(25, 'Military Prop Pay'),
  new IdValue(26, 'Military Overseas Pay'),
  new IdValue(27, 'Military Combat Pay'),
  new IdValue(28, 'Military Variable Housing Allowance'),
  new IdValue(31, 'Other'),
  new IdValue(45, 'Contract Basis'),
];

export const nonEmploymentIncomeTypes: IdValue[] = [
  new IdValue(5, 'Dividend Interest'),
  new IdValue(7, 'Alimony/Child Support'),
  new IdValue(8, 'Automobile Expense Account'),
  new IdValue(9, 'Foster Care'),
  new IdValue(10, 'Notes Receivable Installment'),
  new IdValue(11, 'Retirement - Pension'),
  new IdValue(12, 'Social Security'),
  new IdValue(13, 'Subject Property Net Cash Flow'),
  new IdValue(14, 'Trust'),
  new IdValue(15, 'Unemployment Benefits'),
  new IdValue(16, 'Public Assistance'),
  new IdValue(17, 'VA Benefits Non-Educational'),
  new IdValue(18, 'Mortgage Differential'),
  new IdValue(29, 'Mortgage Credit Certificate'),
  new IdValue(30, 'Trailing CoBorrower Income'),
  new IdValue(32, 'Boarder Income'),
  new IdValue(33, 'Capital Gains'),
  new IdValue(34, 'Employment Related Assets'),
  new IdValue(35, 'Foreign Income'),
  new IdValue(36, 'Royalty Payment'),
  new IdValue(37, 'Seasonal Income'),
  new IdValue(38, 'Temporary Leave'),
  new IdValue(39, 'Tip Income'),
  new IdValue(40, 'Housing Choice Voucher Program (Section 8)'),
  new IdValue(41, 'Fannie Mae - Non Borrower Household Income'),
  new IdValue(42, 'Accessory Unit Income'),
  new IdValue(43, 'Alimony'),
  new IdValue(44, 'Child Support'),
  new IdValue(46, 'Retirement - Defined Contribution Plan (IRA, 401K, etc)'),
  new IdValue(47, 'Disability'),
  new IdValue(48, 'Housing Allowance - Housing or Parsonage'),
  new IdValue(49, 'Separate Maintenance'),
];

export enum IncomeType {
  BaseIncome = 1,
  Overtime = 2,
  Bonus = 3,
  Commission = 4,
  DividendInterest = 5,
  //[OmitValue]
  NetRentalIncome = 6,
  AlimonyChildSupport = 7,
  AutomobileExpenseAccount = 8,
  FosterCare = 9,
  NotesReceivableInstallment = 10,
  Pension = 11,
  SocialSecurity = 12,
  SubjectPropertyNetCashFlow = 13,
  Trust = 14,
  Unemployment = 15,
  PublicAssistance = 16,
  VABenefitsNonEducational = 17,
  MortgageDifferential = 18,
  MilitaryBasePay = 19,
  MilitaryRationsAllowance = 20,
  MilitaryFlightPay = 21,
  MilitaryHazardPay = 22,
  MilitaryClothesAllowance = 23,
  MilitaryQuartersAllowance = 24,
  MilitaryPropPay = 25,
  MilitaryOverseasPay = 26,
  MilitaryCombatPay = 27,
  MilitaryVariableHousingAllowance = 28,
  MortgageCreditCertificate = 29,
  TrailingCoBorrowerIncome = 30,
  Other = 31,
  BoarderIncome = 32,
  CapitalGains = 33,
  EmploymentRelatedAssets = 34,
  ForeignIncome = 35,
  RoyaltyPayment = 36,
  SeasonalIncome = 37,
  TemporaryLeave = 38,
  TipIncome = 39,
  Section8 = 40,
  NonBorHouseholdIncome = 41,
  AccessoryUnitIncome = 42,
  Alimony = 43,
  ChildSupport = 44,
  ContractBasis = 45,
  DefinedContributionPlan = 46,
  Disability = 47,
  HousingAllowance = 48,
  SeparateMaintenance = 49,
}
